/* MCR · Buy 1 Get 1: after an add, offer the free piece when the cart holds an odd quantity of this product. */
(function () {
  if (window.__mcrBogo) return;
  window.__mcrBogo = true;

  /* Checkout through Razorpay Magic: click a hidden cart "checkout" button, which the Magic Checkout app embed
     (and the classic script) intercept. If nothing takes the click, fall back to Shopify checkout. */
  function goCheckout() {
    var b = document.createElement('button');
    b.type = 'button'; b.name = 'checkout'; b.hidden = true;
    document.body.appendChild(b);
    var ev = new MouseEvent('click', { bubbles: true, cancelable: true });
    var untouched = b.dispatchEvent(ev);
    setTimeout(function () { b.remove(); }, 0);
    if (!untouched) return;
    // the click was not cancelled: give Razorpay a moment to open its frame before falling back
    setTimeout(function () {
      var rz = document.querySelector('.razorpay-container, .razorpay-checkout-frame, iframe[src*="razorpay"]');
      if (!rz || rz.offsetParent === null && getComputedStyle(rz).position !== 'fixed') window.location = '/checkout';
    }, 900);
  }

function fmtMoney(cents, format) {
    var n = cents / 100;
    var f = format || "Rs. {{amount}}";
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k.indexOf("no_decimals") > -1) return Math.round(n).toLocaleString("en-IN");
      return n.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }).replace(/<[^>]*>/g, "");
  }

  function init() {
    var dlg = document.querySelector('[data-mcr-bogo]');
    if (!dlg || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    var variants;
    try { variants = JSON.parse(dlg.querySelector('[data-bogo-variants]').textContent); } catch (e) { return; }
    var productId = +dlg.dataset.productId;
    var sIdx = +dlg.dataset.sizeIndex || 0;
    var prop = dlg.dataset.property;
    var sizesEl = dlg.querySelector('[data-bogo-sizes]');
    var addBtn = dlg.querySelector('[data-bogo-add]');
    var err = dlg.querySelector('[data-bogo-err]');
    var tpl = document.querySelector('[data-bogo-buynow-tpl]');
    var btns = document.querySelector('product-form .product-form__buttons');
    if (tpl && btns && !btns.querySelector('[data-bogo-buynow]')) btns.appendChild(tpl.content.cloneNode(true));
    var chosen = null;
    var busy = false;

    function money(c) { return fmtMoney(c, dlg.dataset.moneyFormat); }
    function styleLabel(v) {
      return v.o.filter(function (_, i) { return i !== sIdx; }).join(' · ');
    }

    // Free piece = the SAME shirt the shopper picked: same size AND same sleeve (client 2026-10-10:
    // half sleeve → free half sleeve, full → free full). Nothing to choose; the popup just confirms it.
    function open(paid, missing) {
      var size = paid.o[sIdx];
      var options = variants.filter(function (v) { return v.id === paid.id; });
      chosen = options.find(function (v) { return v.ok; }) || null;
      if (!chosen) { if (window.__mcrBogoCheckout) goCheckout(); return; }
      dlg.dataset.qty = missing;
      dlg.dataset.done = '0';
      var style = styleLabel(paid);
      dlg.querySelector('[data-bogo-sub]').textContent = (missing > 1 ? missing + ' free shirts' : '1 free shirt') + ' · Size ' + size + (style ? ' · ' + style : '') + ' (same as your shirt)';
      var lbl = dlg.querySelector('.mcr-bogo-dlg__label');
      if (lbl) lbl.hidden = true;
      sizesEl.innerHTML = options.map(function (v) {
        return '<button type="button" role="radio" class="mcr-bogo-dlg__size mcr-bogo-dlg__size--wide" data-id="' + v.id + '" aria-checked="' + (v === chosen) + '"' + (v.ok ? '' : ' disabled') + '>' + styleLabel(v) + '</button>';
      }).join('');
      paint();
      err.hidden = true;
      if (!dlg.open) dlg.showModal();
    }
    function paint() {
      var img = dlg.querySelector('[data-bogo-img]');
      if (chosen && chosen.img) { img.src = chosen.img; img.hidden = false; } else img.hidden = true;
      if (chosen) dlg.querySelector('[data-bogo-mrp]').textContent = money(chosen.price);
    }

    sizesEl.addEventListener('click', function (e) {
      var b = e.target.closest('[data-id]');
      if (!b || b.disabled) return;
      chosen = variants.find(function (v) { return v.id === +b.dataset.id; });
      sizesEl.querySelectorAll('[data-id]').forEach(function (x) { x.setAttribute('aria-checked', x === b); });
      paint();
    });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.closest('[data-bogo-close]')) dlg.close();
    });
    dlg.addEventListener('close', function () {
      // "Buy now" shoppers who skip the free piece still go straight to checkout
      if (window.__mcrBogoCheckout && !busy && dlg.dataset.done !== '1') goCheckout();
    });

    // Buy now: add to cart through the normal form (so the free-piece popup runs), then checkout.
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-bogo-buynow]');
      if (!b) return;
      var form = document.querySelector('product-form form[action*="/cart/add"]');
      var submit = form && form.querySelector('[type="submit"]');
      if (!submit || submit.disabled) return;
      window.__mcrBogoCheckout = true;
      submit.click();
    });

    addBtn.addEventListener('click', function () {
      if (!chosen || busy) return;
      busy = true; addBtn.disabled = true;
      var body = { id: chosen.id, quantity: +dlg.dataset.qty || 1 };
      if (prop) { body.properties = {}; body.properties[prop.split(':')[0].trim()] = (prop.split(':')[1] || 'Free').trim(); }
      var drawer = document.querySelector('cart-drawer');
      if (drawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          busy = false; addBtn.disabled = false;
          if (!res.ok) { err.textContent = res.j.description || 'Could not add the free piece'; err.hidden = false; return; }
          dlg.dataset.done = '1';
          dlg.close();
          if (window.__mcrBogoCheckout) { goCheckout(); return; }
          if (drawer && res.j.sections) drawer.renderContents(res.j);
          else if (!drawer) window.location = window.routes.cart_url;
        })
        .catch(function () { busy = false; addBtn.disabled = false; err.textContent = 'Network error — please try again'; err.hidden = false; });
    });

    subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
      if (!ev || ev.source !== 'product-form') return;
      var paid = variants.find(function (v) { return v.id === +ev.productVariantId; });
      if (!paid) return;
      fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var total = 0;
          cart.items.forEach(function (it) { if (it.product_id === productId) total += it.quantity; });
          if (total % 2 === 1) setTimeout(function () { open(paid, 1); }, 450);
          else if (window.__mcrBogoCheckout) goCheckout();
        })
        .catch(function () {});
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
